/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

export class Branding {
  constructor(
    public primaryColor = '#D90119',
    public secondaryColor = '#B60207',
    public systemColor = '#F2F3F3',
    public fontColor = '#F2F3F3',
    public navIconColor = '#FFFFFF',
    public companyLogo?: string | null,
    public emailLogo?: string | null,
    public documentLogo?: string | null,
    public favIcon?: string | null,
    public loginLogo?: string | null,
    public clientId?: number | null,
    public id?: number,
    public createdAt?: string,
    public updatedAt?: string
  ) {}
}

export enum BRANDING_LOGO_TYPES {
  COMPANY = 'companyLogo',
  EMAIL = 'emailLogo',
  DOCUMENT = 'documentLogo',
  LOGIN = 'loginLogo',
  FAVICON = 'favIcon',
}
